/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const ErrorIcon = (props) => (
  <SvgIcon
    style={{
      width: '22px',
      height: '18px',
    }}
    viewBox="0 0 22 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="messages"
        transform="translate(-103.000000, -297.000000)"
        fill={props.fill}
        fillRule="nonzero"
      >
        <g id="error" transform="translate(103.000000, 297.000000)">
          <path
            d="M10.0664844,0.559777888 L1.04409275,16.1777497 C0.585826097,16.9710836 1.11296815,18 1.97761785,18 L20.0223571,18 C20.8870839,18 21.4141764,16.9710836 20.9558877,16.1777497 L11.9335566,0.559777888 C11.5023491,-0.186593225 10.4976588,-0.186592034 10.0664844,0.559777888 Z M9.875,6.75000375 C9.875,6.12868668 10.3786712,5.625 11.0000056,5.625 C11.62134,5.625 12.125,6.12868668 12.125,6.75000375 L12.125,11.2500188 C12.125,11.8713358 11.62134,12.375 11.0000056,12.375 C10.3786712,12.375 9.875,11.8713358 9.875,11.2500188 L9.875,6.75000375 Z M9.875,14.625 C9.875,14.0036625 10.3786712,13.5 11.0000056,13.5 C11.62134,13.5 12.125,14.0036625 12.125,14.625 C12.125,15.2463375 11.62134,15.75 11.0000056,15.75 C10.3786712,15.75 9.875,15.2463375 9.875,14.625 Z"
            id="error-path-1"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

ErrorIcon.propTypes = {
  title: PropTypes.string,
  fill: PropTypes.string,
};

ErrorIcon.defaultProps = {
  title: '',
  fill: '#D34343',
};

export default ErrorIcon;
